import { frontendURL } from '../../../../helper/URLHelper';
import { RELEASE_NOTE_VIEW_PERMISSIONS } from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

// `agent` continua na lista de propósito: quem não tem função personalizada não tem tela onde
// alguém marque release_note_view, então tirá-lo daqui esconderia as notas de todo atendente
// comum sem forma de devolver. A permissão governa quem TEM função personalizada — que é onde
// o administrador consegue decidir.
//
// Exportado porque o item da barra lateral (sidebarItems/settings.js) declara a mesma lista:
// duas cópias divergem calado, e quem editar uma esquece a outra.
export const RELEASE_NOTES_PERMISSIONS = [
  'administrator',
  'agent',
  RELEASE_NOTE_VIEW_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/release_notes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'release_notes_wrapper',
          meta: {
            permissions: RELEASE_NOTES_PERMISSIONS,
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'release_notes_list',
          meta: {
            permissions: RELEASE_NOTES_PERMISSIONS,
          },
          component: Index,
        },
      ],
    },
  ],
};
